export default "__VITE_ASSET__CkOXplfL__"